import { FETCH_SHIPPING_OPTIONS, CHANGE_SHIPPING_METHOD, CHANGE_SHIPPING_ADDRESS } from "./actions";
import { Shipping, ShippingOption } from "./types";

const initialState: Shipping = null;

export function shippingReducer(
    state = initialState,
    action: any
): Shipping {
    switch (action.type) {
        case FETCH_SHIPPING_OPTIONS: {
            const shipping = action.payload;
            const options: ShippingOption[] = [];
            if (shipping.pickUp.enabled) {
                options.push({
                    id: 'pickUp',
                    method: 'pickUp',
                    grossPrice: shipping.pickUp.grossPrice,
                    name: 'Pick-up',
                    priceType: 'fixed',
                    distance: 0,
                });
            }
            if (shipping.shipping?.options) {
                options.push(...shipping.shipping.options);
            }

            return {
                ...state,
                options: options,
                selectedMethodId: shipping.selectedMethod?.id,
            };
        }
        case CHANGE_SHIPPING_METHOD: {
            return { ...state, selectedMethodId: action.payload.id }
        }
        case CHANGE_SHIPPING_ADDRESS: {
            return { ...state, shippingAddress: action.payload}
        }
        default:
            return state
    }
}
